import { styled } from "@mui/material/styles";

const Item = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  [theme.breakpoints.down("xs")]: {
    textAlign: "center",
  },
  [theme.breakpoints.down("lg")]: {
    textAlign: "left",
  },
  color: "#011E41",
  fontWeight: 400,
}));

export default Item;
